export default class DatePicker {
    constructor(el, options) {
        this.element = null;
        this.inputElement = null;
        this.toggle = null;
        this.dayTriggers = null;
        this.closeTrigger = null;
        this.todayTrigger = null;

        this.onToggleClickedBound = this.onToggleClicked.bind(this);
        this.onDayClickedBound = this.onDayClicked.bind(this);
        this.onDocumentClickBound = this.onDocumentClick.bind(this);
        this.onCloseClickedBound = this.onCloseClicked.bind(this);
    };

    attach(element) {
        if (!element) {
            return;
        }
        this.element = element;
        this.toggle = this.element.querySelector('.js-date-picker-toggle');
        this.inputElement = this.element.querySelector('.js-date-picker-input');
        this.dayTriggers = this.element.querySelectorAll('.js-day-picker-day-trigger');
        this.closeTrigger = this.element.querySelector('.js-date-picker-close-trigger');
        this.todayTrigger = this.element.querySelector('.js-date-picker-today-trigger');

        document.addEventListener('click', this.onDocumentClickBound, false);
        this.closeTrigger.addEventListener('click', this.onCloseClickedBound, false);
        this.toggle.addEventListener('click', this.onToggleClickedBound, false);
        if (this.todayTrigger) {
            this.todayTrigger.addEventListener('click', this.onDayClickedBound, false);
        }

        for (var index in this.dayTriggers) {
            if (!this.dayTriggers.hasOwnProperty(index) || !(this.dayTriggers[index] instanceof HTMLElement)) continue;
            this.dayTriggers[index].addEventListener('click', this.onDayClickedBound, false);
        }
    };

    detach() {
        if (!this.element) {
            return;
        }

        document.removeEventListener('click', this.onDocumentClickBound, false);
        this.closeTrigger.addEventListener('click', this.onCloseClickedBound, false);
        this.toggle.removeEventListener('click', this.onToggleClickedBound, false);
        if (this.todayTrigger) {
            this.todayTrigger.removeEventListener('click', this.onDayClickedBound, false);
        }
        for (var index in this.dayTriggers) {
            if (!this.dayTriggers.hasOwnProperty(index) || !(this.dayTriggers[index] instanceof HTMLElement)) continue;
            this.dayTriggers[index].removeEventListener('click', this.onDayClickedBound, false);
        }

        this.todayTrigger = null;
        this.closeTrigger = null;
        this.dayTriggers = null;
        this.toggle = null;
        this.inputElement = null;
        this.element = null;
    };

    onToggleClicked(e) {
        e.preventDefault();

        if (this.element.classList.contains('-open')) {
            this.hideOptions();
        } else {
            this.showOptions();
        }
    };

    onDayClicked(e) {
        var day = e.target.getAttribute('data-id');
        if (!day) {
            e.preventDefault()
        }

        this.setValue(day);
    };

    onCloseClicked(e) {
        e.preventDefault();

        this.hideOptions();
    };

    onDocumentClick(e) {
        var insideDataPicker = false;

        var current = e.target;
        while (current instanceof HTMLElement) {
            if (current.classList.contains('js-date-picker')) {
                insideDataPicker = true;
                break;
            }

            current = current.parentNode;
        }

        if (!insideDataPicker) {
            this.hideOptions();
        }
    };

    showOptions() {
        this.element.classList.add('-open');
    };

    hideOptions() {
        this.element.classList.remove('-open');
    };

    setValue(value) {
        this.inputElement.value = value;
    };
}